import React from 'react';
import dynamic from "next/dynamic";
import Meta from "../Meta";
import { RenderArticleSchema } from "../../helpers/Helper";
import { useAppContext } from "@components/Provider";

import styles from "./Funnel.module.css";
import "./Funnel.css";

const PageBuilder = dynamic(() => import("../../helpers/PageBuilder"));
const Funnel = (props) => {
  const { post } = props.data[0].Post,
    { siteId, data, host } = useAppContext(),
    { SiteSettings } = data || {};

  const siteName =
    SiteSettings.site_footer && SiteSettings.site_footer.share_url;

  const pageBuilderOptions = {
    Newsletter_Settings: {
      ...SiteSettings.newsletter_settings,
    },
    postType: post.post_type,
    button: true,
    funnelPage: true,
  };

  const renderPage = () => {
    return (
      <div className={[styles["Funnel"], "Funnel"].join(" ")}>
        <Meta url={props.pageUrl} post={post} siteName={siteName} isNewAppRouter={true} />
          <div className="Funnel-content">
            <PageBuilder
              post={post}
              siteId={siteId}
              pageBuilderOptions={pageBuilderOptions}
              disableOptions={"funnel"}
            />
          </div>
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={RenderArticleSchema(
              post,
              props,
              SiteSettings,
              siteId,
              host
            )}
          />
      </div>
    );
  };

  return <React.Fragment>{renderPage()}</React.Fragment>;
};

export default Funnel;
